import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-csgo-bg pt-24 md:pt-32 pb-16">
      <div className="fixed inset-0 bg-grid opacity-20 pointer-events-none" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="font-orbitron font-black text-4xl md:text-5xl text-white mb-4">
            Privacy <span className="text-csgo-primary">Policy</span>
          </h1>
          <p className="font-rajdhani text-csgo-textMuted">
            Last updated: January 2026
          </p>
        </div>

        <div className="bg-csgo-surface/60 border border-csgo-border rounded-xl p-6 md:p-8 space-y-8">
          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">1. Introduction</h2>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed">
              This Privacy Policy explains how we collect, use, and protect your information when you visit our website promoting CSGOLuck promo codes. We are committed to protecting your privacy and ensuring transparency about our data practices.
            </p>
          </section>

          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">2. Information We Collect</h2>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed mb-4">
              We may collect the following types of information:
            </p>
            <ul className="font-rajdhani text-csgo-textMuted space-y-2 list-disc list-inside">
              <li>Browser type and version</li>
              <li>Operating system</li>
              <li>Referring website</li>
              <li>Pages visited and time spent on our website</li>
              <li>IP address (anonymized)</li>
              <li>Device information</li>
            </ul>
          </section>

          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">3. How We Use Your Information</h2>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed mb-4">
              We use the collected information for:
            </p>
            <ul className="font-rajdhani text-csgo-textMuted space-y-2 list-disc list-inside">
              <li>Improving our website and user experience</li>
              <li>Analyzing website traffic and usage patterns</li>
              <li>Ensuring website security</li>
              <li>Complying with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">4. Third-Party Services</h2>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed">
              Our website contains links to CSGOLuck and other third-party websites. We are not responsible for the privacy practices of these external sites. We encourage you to read the privacy policies of any third-party websites you visit.
            </p>
          </section>

          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">5. Cookies</h2>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed">
              We use cookies and similar tracking technologies to enhance your browsing experience. For more information about our use of cookies, please see our <a href="/cookies" className="text-csgo-primary hover:underline">Cookie Policy</a>.
            </p>
          </section>

          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">6. Data Security</h2>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed">
              We implement appropriate security measures to protect your information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.
            </p>
          </section>

          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">7. Your Rights</h2>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed mb-4">
              Depending on your location, you may have the following rights:
            </p>
            <ul className="font-rajdhani text-csgo-textMuted space-y-2 list-disc list-inside">
              <li>Right to access your personal data</li>
              <li>Right to request correction of your data</li>
              <li>Right to request deletion of your data</li>
              <li>Right to opt-out of certain data processing</li>
            </ul>
          </section>

          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">8. Children's Privacy</h2>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed">
              Our website is not intended for individuals under the age of 18. We do not knowingly collect personal information from children. If you are a parent or guardian and believe your child has provided us with personal information, please contact us.
            </p>
          </section>

          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">9. Changes to This Policy</h2>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed">
              We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.
            </p>
          </section>

          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">10. Contact Us</h2>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed">
              If you have any questions about this Privacy Policy, please contact us through the appropriate channels.
            </p>
          </section>
        </div>

        <div className="mt-8 text-center">
          <p className="font-rajdhani text-sm text-csgo-textMuted">
            This is an affiliate website. We are not affiliated with CSGOLuck or Valve Corporation.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
